import {Injectable} from '@angular/core';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class XsrfInterceptor implements HttpInterceptor {

  private static readonly HEADER_NAME: string = 'X-XSRF-TOKEN';
  private static readonly COOKIE_NAME: string = 'XSRF-TOKEN';

  constructor(
    private cookieService: CookieService,
  ) {
  }

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!url.startsWith(environment.api.baseUrl) || req.method === 'GET' || req.method === 'HEAD') { return next.handle(req); }

    const token = this.cookieService.get(XsrfInterceptor.COOKIE_NAME);

    if (token !== null && !req.headers.has(XsrfInterceptor.HEADER_NAME)) {
      req = req.clone({headers: req.headers.set(XsrfInterceptor.HEADER_NAME, token)});
    }
    return next.handle(req);
  }

}
